<div class="hero" [style.--clip-bg]="clipColor">
  <div class="hero__inner">

    <div class="eyebrow" *ngIf="eyebrowTpl">
      <span class="eyebrow-dot"></span>
      <ng-container *ngTemplateOutlet="eyebrowTpl.template"></ng-container>
    </div>

    <h1 class="hero--heading" *ngIf="headingTpl">
      <ng-container *ngTemplateOutlet="headingTpl.template"></ng-container>
    </h1>

    <div class="hero--sub" *ngIf="subTpl">
      <ng-container *ngTemplateOutlet="subTpl.template"></ng-container>
    </div>

    <ng-content></ng-content>
  </div>
</div>
